// extracted by mini-css-extract-plugin
export default {"overlay":"Mz-z","bodyOpen":"Nz-z","content":"Oz-z","header":"Pz-z","close":"Qz-z","closeNoHeading":"Rz-z"};